import fetch from './index';

// 获取当前章节下的所有随堂练习及题目详情
// GET /exercise/course/chapter/byChapterPidWithQuestionDetails?chapterPid=xxx
const getExercisesByChapterPidWithQuestionDetails = (chapterPid: string) =>
  fetch.axios_admin.get('/exercise/course/chapter/byChapterPidWithQuestionDetails', {
    params: { chapterPid },
  });

export default {
  getExercisesByChapterPidWithQuestionDetails,
};

// 批量保存练习课程章节关联
// POST /exercise/course/chapter/batch
export const batchSaveExercises = (data: Array<{ chapterPid: string; ojQuestionPid: number; pid?: number }>) =>
  fetch.axios_admin.post('/exercise/course/chapter/batch', data);

export { getExercisesByChapterPidWithQuestionDetails };

// 根据主键删除练习课程章节关联
// DELETE /exercise/course/chapter/{pid}
export const removeExercise = (pid: number | string) =>
  fetch.axios_admin.remove(`/exercise/course/chapter/${pid}`);

// 更新随堂练习排序
// POST /exercise/course/chapter/updateSortOrderByFrontend
export const updateExerciseSortOrder = (chapterPid: string, orderedQuestionIds: number[]) =>
  fetch.axios_admin.post('/exercise/course/chapter/updateSortOrderByFrontend', {
    chapterPid,
    orderedQuestionIds,
  });


